import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/content/editor/:parent',
    name: 'editor',
    component: () => import(/* webpackChunkName: "editor" */ '../views/Editor.vue'),
  },
  {
    path: '/content/:slug',
    name: 'articles',
    component: () => import(/* webpackChunkName: "article" */ '../views/Articles.vue'),
  },
  {
    path: '/products',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '../views/Product.vue'),
  },
  {
    path: '/pages',
    name: 'pageEditor',
    component: () => import(/* webpackChunkName: "pageEditor" */ '../views/PageEditor.vue'),
  },
  {
    path: '/subscribers',
    name: 'subscriber',
    component: () => import(/* webpackChunkName: "subscriber" */ '../views/Subscriber.vue'),
  },
  {
    path: '/config/menu',
    name: 'menuManager',
    component: () => import(/* webpackChunkName: "menuManager" */ '../views/MenuManager.vue'),
  },
  {
    path: '/event/landing-page',
    name: 'eventLandingPage',
    component: () => import(/* webpackChunkName: "eventLandingPage" */ '../views/EventEditor.vue'),
  },
  {
    path: '/gallery/:slug',
    name: 'gallery',
    component: () => import(/* webpackChunkName: "article" */ '../views/Gallery.vue'),
  },
  {
    path: '/slider',
    name: 'slider',
    component: () => import(/* webpackChunkName: "slider" */ '../views/Slider.vue'),
  },
  {
    path: '/web/config',
    name: 'webConfig',
    component: () => import(/* webpackChunkName: "webConfig" */ '../views/WebConfig.vue'),
  },
  {
    path: '/users/:role',
    name: 'users',
    component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
  },
  {
    path: '/media/all',
    name: 'media',
    component: () => import(/* webpackChunkName: "media" */ '../views/Media.vue'),
  },
  {
    path: '/:type/category',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'),
  },
  {
    path: '/media/embed/:id',
    name: 'embed',
    component: () => import(/* webpackChunkName: "embed" */ '../views/Embed.vue'),
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import(/* webpackChunkName: "signin" */ '../views/Signin.vue'),
  },
  {
    path: '/user/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue'),
  },

  {
    path: '/table-editor',
    name: 'tableEditor',
    component: () => import(/* webpackChunkName: "tableEditor" */ '../views/TableEditor.vue'),
  },

  /**
   * Event
   *
   */
  {
    path: '/event/overview',
    name: 'absenOverview',
    component: () => import(/* webpackChunkName: "absenOverview" */ '../views/AbsenOverview.vue'),
  },
  {
    path: '/event/all',
    name: 'allEvent',
    component: () => import(/* webpackChunkName: "allEvent" */ '../views/AllEvent.vue'),
  },
  {
    path: '/event/scaner',
    name: 'absensi',
    component: () => import(/* webpackChunkName: "absensi" */ '../views/Absensi.vue'),
  },
  {
    path: '/event/guest',
    name: 'guestList',
    component: () => import(/* webpackChunkName: "guestList" */ '../views/GuestList.vue'),
  },

  {
    path: '/auth/redirect',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "Auth" */ '../views/Auth.vue'),
  },

  {
    path: '/logs',
    name: 'logs',
    component: () => import(/* webpackChunkName: "logs" */ '../views/Logs.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { app }: any = router;
  if (!['/signin', '/auth/redirect'].includes(to.path) && !app.$session.get(`${app.$config.appId}_jwt`)) {
    next(`/signin?next=${encodeURIComponent(to.fullPath)}`);
    return;
  }
  next();
});

export default router;
